import broadcastNotification from 'src/common/components/Notification/broadcastNotification';
import { EditorListing } from 'src/common/types/api/listings';
import { ListingFetchResult } from './callListingFetch';

type ListingAction = 'publish' | 'unpublish' | 'delete';
const bulkListingActionNotifications = (
  results: ListingFetchResult[],
  listings: EditorListing[],
  action: ListingAction,
): void => {
  const errors = results.filter((r) => !r.success);
  if (errors.length) {
    const headlines = errors.map(
      (err) => listings.find((listing) => listing.id === err.listingId).headline,
    );
    broadcastNotification({
      variant: 'error',
      translation: 'admin-listings',
      i18nKey: `listing-editor-bulk-notifications--${action}-error`,
      translationOption: {
        headline: headlines.join(', '),
        count: headlines.length,
      },
    });
  } else {
    const successCount = results.filter((r) => r.success).length;
    broadcastNotification({
      variant: 'success',
      translation: 'admin-listings',
      i18nKey: `listing-editor-bulk-notifications--${action}`,
      translationOption: {
        count: successCount,
      },
    });
  }
};

export default bulkListingActionNotifications;
